<template>
  <div class="allienceActive">
    <div class="choose-state">
      <span
        v-for="(choose, index) in chooses"
        :key="choose.name"
        @click="active(index, choose.name)"
        :class="isClass == index ? 'choose' : ''"
        >{{ choose.name }}</span
      >
    </div>
    <template v-if="datas.length != 0">
      <div
        class="public-list-template"
        v-for="data in datas"
        :key="data.id"
        @click="goDetail(data.id)"
      >
        <div class="news-left">
          <img :src="data.imgUrl" v-if="data.imgUrl == null ? false : true" />
        </div>
        <div class="news-right">
          <p>{{ data.headline }}</p>
          <p>
            <!-- <span style="margin-right:.5rem;">浏览:{{data.sees}}</span>
          <span>点赞:{{data.praise}}</span>-->
            <span style="float: right; margin-right: 0.3rem">{{
              data.createtime | times
            }}</span>
          </p>
        </div>
      </div>
    </template>
    <div v-else>
      <noneBox />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      chooses: [
        { name: "联席会议" },
        { name: "志愿服务" },
        { name: "组织活动" },
      ],
      isClass: 0,
      datas: [],
      name: "联席会议",
      type: ''
    };
  },
  created() {
    this.type = this.$route.query.typeName
  },
  mounted: function () {
    if (sessionStorage.getItem("allienceActive") != null) {
      this.name = sessionStorage.getItem("allienceActive");
      this.isClass = sessionStorage.getItem("allienceActiveIndex");
    }
    this.render();
  },
  methods: {
    render() {
      // this.axios
      //   .get(
      //     `/api/Main/ActivityList?typename=华陆大厦综合党委&name=${this.name}&title=组织活动`
      //   )
      this.axios({
        method: 'get',
        url: '/api/Main/ActivityList',
        params: {
          typename: this.type == 'hualu' ? '华陆大厦综合党委' : '东坡水街商圈综合党委',
          name: this.name,
          title: '组织活动'
        }
      }).then((e) => {
          switch (e.data.code) {
            case 0:
              this.datas = e.data.msg;
              this.datas.forEach((item) => {
                let text = item.memo;
                if (item.memo.indexOf("img") > -1) {
                  let textStart = item.memo.indexOf("img");
                  let textSub = text.substring(textStart + 9);
                  let textEnd = textSub.indexOf("title=");
                  let imgUrl = textSub.substring(0, textEnd - 2);
                  item.imgUrl = imgUrl;
                }
              });
              break;
            default:
              this.datas = [];
              break;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    goDetail(newsid) {
      this.$router.push({
        path: "/publicDetail",
        query: { title: "组织活动", id: newsid, dbnum: 1 },
      });
    },
    active(index, name) {
       if(index == this.isClass) return false
      this.isClass = index;
      this.name = name;
      sessionStorage.setItem("allienceActiveIndex", this.isClass);
      sessionStorage.setItem("allienceActive", this.name);
      this.render();
    },
  },
};
</script>

<style lang="scss" scoped>
.allienceActive {
  .choose-state {
    span {
      display: inline-block;
      width: 33%;
    }
    .choose {
      font-weight: bold;
      color: #ffa000;
    }
    // align-items: center;
    // color: #999999;
    // display: flex;
    text-align: center;
    width: 100%;
    overflow-x: scroll;
    white-space: nowrap;
    background: #fff;
    line-height: 3;
  }
  .public-list-template {
    font-size: 0.3rem;
    width: 94%;
    margin: 0 auto;
    display: flex;
    margin-bottom: 0.2rem;
    background: #fff;
    padding: 0.2rem 0;
    margin-top: 0.2rem;
    //   align-items: center;
    .news-right {
      width: 100%;
      margin-left: 0.2rem;
      p:nth-child(1) {
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
        display: -webkit-box;
        margin-bottom: 0.3rem;
        line-height: 1.8;
      }
      p:nth-child(2) {
        // border-top: 0.01rem solid #e6e6e6;
        padding-top: 0.2rem;
        color: #999999;
        font-size: 0.26rem;
      }
    }
    .news-left {
      img {
        width: 2.4rem;
        height: 2rem;
      }
    }
  }
  padding-top: 1rem;
  font-size: 0.3rem;
}
</style>